import axios from 'axios';
import globals from '../globals';

const StoreApi = axios.create({ baseURL: globals().storeUrl });

export default StoreApi;
